<template>
  <div class="card card-custom" v-if="course">
    <div class="card-body p-0">
      <div class="row justify-content-center my-10 px-8 my-lg-15 px-lg-10">
        <div class="col-xl-12">
          <v-tabs
            v-model="tab"
            background-color="pink lighten-2"
            grow
            icons-and-text
            dark
            class="mb-10"
          >
            <v-tabs-slider></v-tabs-slider>

            <v-tab href="#tab-FR">
              Français
              <img
                src="/media/svg/flags/019-france.svg"
                class="h-20px w-20px rounded-sm"
              />
            </v-tab>
            <v-tab href="#tab-EN">
              Anglais
              <img
                src="/media/svg/flags/226-united-states.svg"
                class="h-20px w-20px rounded-sm"
              />
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab">
            <v-tab-item value="tab-FR">
              <v-form ref="form">
                <FormCourseStep1
                  v-if="course"
                  v-model="course"
                  @openFileDropEdit="fileDialog = true"
                  mode="edit"
                ></FormCourseStep1
              ></v-form>
            </v-tab-item>
            <v-tab-item value="tab-EN">
              <v-form ref="form">
                <FormCourseStep2 v-model="course"></FormCourseStep2
              ></v-form>
            </v-tab-item>
          </v-tabs-items>
          <VideosTable
            v-model="course"
            @addVideo="addVideo"
            @removeVideo="removeVideo"
          ></VideosTable>
          <v-btn class="ma-2 float-right" color="primary" @click="submit">
            Valider les modifications
          </v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import Api from "@/core/services/api.service";
import Swal from "sweetalert2";

import FormCourseStep1 from "@/components/admin/course/forms/wizard/formCourseStep1.vue";
import FormCourseStep2 from "@/components/admin/course/forms/wizard/formCourseStep2.vue";
import VideosTable from "@/components/admin/course/forms/videos/videoTable.vue";

export default {
  name: "editCourse",
  components: {
    FormCourseStep1,
    FormCourseStep2,
    VideosTable,
  },
  data: () => ({
    tab: null,
    course: null,
    themes: [],
    open: [1, 2],
    search: null,
    caseSensitive: false,
  }),
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Administration", route: "gestionContenus" },
      { title: "Gestion des contenus", route: "gestionContenus" },
      { title: "Modifier un parcours" },
    ]);

    // TODO: Refactoring: Supprimer cette appel API qui semble ne pas être utile ?
    Api.get("themes").then((themes) => {
      this.themes = themes.data["hydra:member"];
    });

    const courseId = this.$route.params.id;

    Api.get('courses', courseId, { headers: { 'Accept-Language': 'fr_FR' } }).then((course) => {
      this.populateCourseForm(course.data);
    });
  },
  methods: {
    submit: async function () {
      if (!this.$refs.form.validate()) {
        Swal.fire({
          //Swal = Sweet Alert
          title: "Impossible de modifier le parcours",
          text:
            "Vérifier les champs du formulaire avant de pouvoir modifier le parcours. Certaines informations sont obligatoires et signalées par un astérisque (*)",
          icon: "warning",
          confirmButtonClass: "btn btn-secondary",
        });
      } else {
        const keywords = await Promise.all([
          ...this.course.keywords.visibleFR.map((k) =>
            typeof k === "string"
              ? Api.post("keywords", {
                  name: k,
                  lang: "FR",
                  isVisible: true,
                }).then((res) => res.data)
              : Promise.resolve(k)
          ),
          ...this.course.keywords.visibleEN.map((k) =>
            typeof k === "string"
              ? Api.post("keywords", {
                  name: k,
                  lang: "EN",
                  isVisible: true,
                }).then((res) => res.data)
              : Promise.resolve(k)
          ),
          ...this.course.keywords.invisibleFR.map((k) =>
            typeof k === "string"
              ? Api.post("keywords", {
                  name: k,
                  lang: "FR",
                  isVisible: false,
                }).then((res) => res.data)
              : Promise.resolve(k)
          ),
          ...this.course.keywords.invisibleEN.map((k) =>
            typeof k === "string"
              ? Api.post("keywords", {
                  name: k,
                  lang: "EN",
                  isVisible: false,
                }).then((res) => res.data)
              : Promise.resolve(k)
          ),
        ]);

        let response;
        try {
          response = await Api.patch('courses', this.course.id, {
            title: this.course.title,
            description: this.course.description,
            keywords: keywords.map((k) => k["@id"]),
            theme: this.course.theme[0]["@id"],
            isVisible: this.course.isVisible,
            videoCourses: this.course.videos.map(v => ({
              position: v.position,
              video: v['@id']
            })), // Les vidéos du parcours sont converties en objet videoCourses pour enregistrer la position des vidéos dans le parcours
          }, { headers: { 'Accept-Language': 'fr_FR' } });
          await Api.patch('courses', response.data.id, {
            title: this.course.titleEN,
            description: this.course.descriptionEN
          }, { headers: { 'Accept-Language': 'en_GB' } });
        } catch (error) {
          console.error(error);
          Swal.fire({
            title: "",
            text: "Une erreur est survenue lors de la modification du parcours",
            icon: "error",
            confirmButtonClass: "btn btn-secondary",
          });
          return;
        }

        var bodycourse = new FormData();
        bodycourse.append("poster", this.course.posterFile);

        try {
          if (this.course.posterFile)
            await Api.post(`courses/${response.data.id}/media`, bodycourse);
          Swal.fire({
            title: "",
            text: "Le parcours a été modifié.",
            icon: "success",
            confirmButtonClass: "btn btn-secondary",
          });
          this.$router.push({
            name: "gestionContenus",
            query: {
              selected: "tab-courses",
            },
          });
        } catch (error) {
          console.error(error);
          //Dans le cas où la première requête à réussi, mais que nous n'avons pas réussi à rajouter les fichiers avec la 2eme requête
          Swal.fire({
            title: "",
            text:
              "Le parcours à bien été modifiée, cependant une erreur est survenue lors de la modification du fichier. Vous pouvez modifier le parcours pour le rajouter",
            icon: "error",
            confirmButtonClass: "btn btn-secondary",
          });
          this.$router.push({
            name: "gestionContenus",
            query: {
              selected: "tab-courses",
            },
          });
        }
      }
    },
    populateCourseForm: async function(course) {
      const response = await Api.get('courses', course.id, { headers: { 'Accept-Language': 'en_GB' } });
      this.course = {
        //SPREAD OPERATOR (...)
        //Décomposition d'objets, permet de récupérer toutes les propriétés d'un objet d'un coup et de n'en surcharger
        //que certaines (par exemple Keywords, qu'on a besoin de traiter à part )
        ...course,
        titleEN: response.data.title,
        descriptionEN: response.data.description,
        posterFile: null,

        keywords: {
          visibleEN: course.keywords.filter(
            (k) => k.lang === "EN" && k.isVisible
          ),
          visibleFR: course.keywords.filter(
            (k) => k.lang === "FR" && k.isVisible
          ),
          invisibleEN: course.keywords.filter(
            (k) => k.lang === "EN" && !k.isVisible
          ),
          invisibleFR: course.keywords.filter(
            (k) => k.lang === "FR" && !k.isVisible
          ),
        },
        theme: [course.theme],
      };
    },
    removeActiveTheme() {
      this.course.themeSelected = [];
    },
    addVideo(video) {
      // TODO: Vérifier si la nouvelle vidéo n'est pas déjà présente dans le parcours avant de l'ajouter et afficher message à l'utilisateur
      this.course.videos.push(video);
    },
    removeVideo(video) {
      this.course.videos = this.course.videos.filter((v) => v.id !== video.id);
    },
  },
  computed: {
    apiUrl() {
      return process.env.VUE_APP_API;
    },

    filter() {
      return this.caseSensitive
        ? (item, search, textKey) => item[textKey].indexOf(search) > -1
        : undefined;
    },
  },
};
</script>
